import React from "react";
import "../App.css"; // Main CSS file
import logo from "../assets/logo.png"; // Import the logo

function HomePage() {
  return (
    <div className="home-page">
      <img src={logo} alt="Timely Logo" className="logo-image" />
      <h1>Welcome to Timely</h1>
      <p>Your smart appointment scheduling assistant.</p>
      <div className="home-buttons">
        <a href="/login" className="btn">
          Login
        </a>
        <a href="/terms" className="btn-secondary">
          Terms & Conditions
        </a>
      </div>
    </div>
  );
}

export default HomePage;
